import {ChartColors as colors} from '../const/dataEnum';

export const createSeriesFromSelectedQuestions = (selectedMultipleQuestions, categoryScore, mockSeries) => {
  const selectedQuestionTitles = selectedMultipleQuestions.map((item) => item.text);

  const series = selectedQuestionTitles
    .map((questionTitle) => {
      let foundSeries = null;
      Object.keys(categoryScore).forEach((categoryName) => {
        const categoryData = categoryScore[categoryName];

        if (categoryData[questionTitle]) {
          const data = categoryData[questionTitle];

          if (data.every((val) => val === 0)) {
            console.warn(`Skipping ${questionTitle} as it has only zeros.`);
            return null;
          }

          foundSeries = {
            data: data,
            label: questionTitle,
          };
        }
      });

      return foundSeries;
    })
    .filter(Boolean);

  return series.length === 0 ? mockSeries : series;
};

export const calculateCategoryScores = (groupedData, periodList) => {
  const categoryScores = {};
  const periodIdToIndex = {};
  periodList.forEach((period, index) => {
    periodIdToIndex[period.data.id] = index;
  });

  // Iterate over grouped data to calculate scores
  groupedData.forEach((group) => {
    const {categoryId, questionCategory, periodId, questions} = group;

    if (!categoryScores[categoryId]) {
      categoryScores[categoryId] = {
        category: questionCategory,
        series: [{}],
      };
    }

    if (!Array.isArray(questions)) {
      console.error(`Invalid question array:`, group);
      return;
    }

    questions.forEach((question) => {
      const {scoreConsolidation, questionTitle} = question;
      const score = scoreConsolidation || 0;

      if (!categoryScores[categoryId].series[0][questionTitle]) {
        categoryScores[categoryId].series[0][questionTitle] = Array(periodList.length).fill(undefined);
      }

      const periodIndex = periodIdToIndex[periodId];
      if (periodIndex === undefined) {
        console.error('Unknown period ID:', periodId);
        return;
      }
      categoryScores[categoryId].series[0][questionTitle][periodIndex] = score;
    });
  });
  return Object.values(categoryScores)
};

export const groupQuestionsByCategoryAndPeriod = (data) => {
  const groupedData = [];
  let categoryIdCounter = 0;
  const categoryMap = {};
  let questionIdCounter = 0;
  data.forEach((item) => {
    const {periodId, periodName, questionCategory, scoreConsolidation, questionTitle} = item;
    if (!(questionCategory in categoryMap)) {
      categoryMap[questionCategory] = categoryIdCounter++;
    }
    const categoryId = categoryMap[questionCategory];
    let existingGroup = groupedData.find(
      (group) =>
        group.periodId === periodId &&
        group.periodName === periodName &&
        group.categoryId === categoryId &&
        group.questionCategory === questionCategory
    );
    if (!existingGroup) {
      existingGroup = {
        periodId,
        periodName,
        categoryId,
        questionCategory,
        questions: [],
      };
      groupedData.push(existingGroup);
    }
    const questionId = `${questionIdCounter++}`;
    existingGroup.questions.push({
      questionId,
      questionTitle,
      scoreConsolidation,
    });
  });
  return groupedData;
};

export const seriesCreator = (data) => {
  const colorList = Object.values(colors);

  return data.map((categoryItem) => {
    const categoryText = categoryItem?.category ?? "Unknown Category";
    const seriesData = categoryItem?.series?.[0] ?? {};

    const transformedSeries = Object.entries(seriesData).map(([questionTitle, scores], index) => ({
      label: questionTitle,
      data: scores,
      color: colorList[index % colorList.length] || "#000000",
    }));

    return {
      category: categoryText,
      series: transformedSeries,
    };
  });
};